






















import { computed, defineComponent, ref } from '@vue/composition-api';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import { useAllResources } from '@/store/modules/resources';
import { useAllSamplingCollections } from '@/store/modules/samplingCollections';
import { LocationCollection, SamplingCollection, Stratification } from '@/store/types';
import soilApiService from '../../services/soilApiService';

export default defineComponent({
	components: { ConfirmDialog },
	props: {
		stratification: {
			type: Object as () => Stratification,
			required: true,
		},
	},
	setup({ stratification }: { stratification: Stratification }, { root }) {
		const showConfirmationDialog = ref<boolean>(false);
		const isLoading = ref(false);
		const errorMessage = ref<string | null>(null);
		const { isLoaded: resourcesAreLoaded } = useAllResources(root.$store);
		const { isLoaded: samplingCollectionsAreLoaded } = useAllSamplingCollections(root.$store);
		const isLoaded = computed(() => resourcesAreLoaded.value && samplingCollectionsAreLoaded.value);

		const draftSamplingCollections = computed(() => {
			const locationCollections: LocationCollection[] = root.$store.getters[
				'resources/getLocationCollectionsByFieldId'
			](stratification.featureOfInterest);
			const locationCollectionIds = locationCollections.map(({ id }) => id);
			const draftSamplingCollections: SamplingCollection[] = root.$store.getters['samplingCollections/getByFieldId'](
				stratification.featureOfInterest
			);
			const draftsWithStratifications = draftSamplingCollections.filter((sc) =>
				locationCollectionIds.includes(sc.object)
			);
			return draftsWithStratifications;
		});

		const handleConfirmDelete = async () => {
			try {
				isLoading.value = true;
				await soilApiService.deleteStratification(stratification.id, true);
				await Promise.all(
					draftSamplingCollections.value.map((sc) =>
						root.$store.dispatch('samplingCollections/deleteSamplingCollection', sc.id)
					)
				);
				showConfirmationDialog.value = false;
				root.$store.dispatch('resources/getAllResources');
			} catch (err) {
				errorMessage.value = 'An error occurred while attempting to delete the stratification. Please try again.';
			} finally {
				isLoading.value = false;
			}
		};

		const handleCleanup = () => {
			errorMessage.value = null;
			isLoading.value = false;
		};

		return {
			showConfirmationDialog,
			isLoading,
			handleConfirmDelete,
			handleCleanup,
			errorMessage,
			isLoaded,
		};
	},
});
